import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Competitor from "components/presentation/Competitor";
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { findArray } from "helpers/utils";

const PreviousCompetitor = ({ data }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()

    let technicalRoutine = false
    let freeRoutine = false
    let acrobaticRoutine = false

    if (data?.results?.eventUnitCode.includes('T-')){
        technicalRoutine = true
    } else if (data?.results?.eventUnitCode.includes('F-')){
        freeRoutine = true
    } else if (data?.results?.eventUnitCode.includes('A-')){
        acrobaticRoutine = true
    }

    let duet = false

    if(!data?.results?.eventUnitCode.includes('TEAM'))
    {
        duet = true
    }

    /*
    let competitorCode = data?.results?.currentExtendedInfos && findArray(data?.results?.currentExtendedInfos, { ei_type: ['DISPLAY'], ei_code: ['LAST_COMP'] })?.ei_value
    let previousCompetitor = data?.results?.items ? data?.results?.items?.find(item => item?.participant?.code === competitorCode) : ''
    let degree = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'DIFFICULTY') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'DIFFICULTY')?.er_value : ''
    let elements = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'ELEMENT') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'ELEMENT')?.er_value : ''
    let artisticImpress = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'IMPRESSION') ? previousCompetitor?.extendedResults?.find(i => i?.er_code === 'IMPRESSION')?.er_value : ''
    */
    
    let previousCompetitor = data?.results?.previousCompetitorResult

    let degree = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'DIFFICULTY')?.er_value || ''
    let elements = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'ELEMENT')?.er_value || ''
    let artisticImpress = previousCompetitor?.extendedResults?.find(i => i?.er_code === 'IMPRESSION')?.er_value || ''
    
    let penalties = ''
    let technicalRoutinePoints = ''

    let freeRoutinePoints, acrobaticRoutinePoints = ''
    if(freeRoutine){
        freeRoutinePoints = ''
    }else if (acrobaticRoutine)
    {
        freeRoutinePoints = ''
        acrobaticRoutinePoints = ''
    }

    return (
        <>
            {technicalRoutine
                ?
                <>
                    {duet 
                        ? <div className="fw-bold"><Label data={'HeaderPreviousDuet'} /></div>
                        : <div className="fw-bold"><Label data={'HeaderPreviousTeam'} /></div>
                    }
                    <table class="table">
                        <thead>
                            <tr>
                                <th className="text-center w-5" scope="col"><Label data={'LabelStartOrder'} /></th>
                                {duet
                                    ? <th className="text-start w-40" scope="col"><Label data={'HeaderDuet'} /></th>
                                    : <th className="text-start w-40" scope="col"><Label data={'HeaderTeam'} /></th>
                                }
                                <th className="text-start w-20" scope="col"><Label data={'HeaderPoints'} /></th>
                                <th className="text-start w-20" scope="col"><Label data={'HeaderTechnicalRoutine'} /></th>
                                <th className="text-start w-20" scope="col"><Label data={'HeaderRank'} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="text-center">{previousCompetitor?.startOrder}</td>
                                <td className="text-start"><Competitor hidePicture={true} alwaysNoc={true} {...previousCompetitor?.participant} /></td>
                                <td>
                                    <Label data="HeaderDegreeOfDiff"/>&ensp;{degree}<br />
                                    <Label data="HeaderElements"/>&ensp;{elements}<br />
                                    <Label data="HeaderArtisticImpression" sport={mirs_discipline}/>&ensp;{artisticImpress}<br />
                                    <Label data="HeaderPenalties"/>&ensp;{penalties}<br />
                                </td>
                                <td className="text-center fw-bold">{technicalRoutinePoints}</td>
                                <td className="text-center fw-bold">{previousCompetitor?.resultRank}</td>
                            </tr>
                        </tbody>
                    </table>
                </>
                : freeRoutine
                    ?
                    <>
                        {duet 
                            ? <div className="fw-bold"><Label data={'HeaderPreviousDuet'} /></div>
                            : <div className="fw-bold"><Label data={'HeaderPreviousTeam'} /></div>
                        }
                        <table class="table">
                            <thead>
                                <tr>
                                    <th className="text-center w-5" scope="col"><Label data={'LabelStartOrder'} /></th>
                                    {duet
                                        ? <th className="text-start w-40" scope="col"><Label data={'HeaderDuet'} /></th>
                                        : <th className="text-start w-40" scope="col"><Label data={'HeaderTeam'} /></th>
                                    }
                                    <th className="text-start w-20" scope="col"><Label data={'HeaderPoints'} /></th>
                                    <th className="text-start w-20" scope="col"><Label data={'HeaderTotalPoints'} /></th>
                                    <th className="text-start w-20" scope="col"><Label data={'HeaderRank'} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">{previousCompetitor?.startOrder}</td>
                                    <td className="text-start">
                                        {previousCompetitor?.teamAthletes?.map((item, key) => (
                                            <div key={'teamComponents-' + key + item.code} >
                                                <Competitor hidePicture={true} hideNoc={false} {...item?.athlete} />
                                            </div>
                                        ))}
                                    </td>
                                    <td>
                                        <Label data="HeaderDegreeOfDiff"/>&ensp;{degree}<br />
                                        <Label data="HeaderElements"/>&ensp;{elements}<br />
                                        <Label data="HeaderArtisticImpression" sport={mirs_discipline}/>&ensp;{artisticImpress}<br />
                                        <Label data="HeaderPenalties"/>&ensp;{penalties}<br />

                                    </td>
                                    <td className="text-center fw-bold">{previousCompetitor?.resultData}</td>
                                    <td className="text-center fw-bold">{previousCompetitor?.resultRank}</td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                    : acrobaticRoutine
                    ?
                    <>
                        <div className="fw-bold"><Label data={'HeaderPreviousTeam'} /></div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th className="text-center w-5" scope="col"><Label data={'LabelStartOrder'} /></th>
                                    <th className="text-start w-40" scope="col"><Label data={'HeaderTeam'} /></th>
                                    <th className="text-start w-20" scope="col"><Label data={'HeaderPoints'} /></th>
                                    <th className="text-start w-20" scope="col"><Label data={'HeaderTotalPoints'} /></th>
                                    <th className="text-start w-20" scope="col"><Label data={'HeaderRank'} /></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center">{previousCompetitor?.startOrder}</td>
                                    <td className="text-start">
                                        {previousCompetitor?.teamAthletes?.map((item, key) => (
                                            <div key={'teamComponents-' + key + item.code} >
                                                <Competitor hidePicture={true} hideNoc={false} {...item?.athlete} />
                                            </div>
                                        ))}
                                    </td>
                                    <td>
                                        <Label data="HeaderDegreeOfDiff"/>&ensp;{degree}<br />
                                        <Label data="HeaderElements"/>&ensp;{elements}<br />
                                        <Label data="HeaderArtisticImpression" sport={mirs_discipline}/>&ensp;{artisticImpress}<br />
                                        <Label data="HeaderPenalties"/>&ensp;{penalties}<br />
                                        <l className="fw-bold"><Label data="HeaderAcrobaticRoutine"/>&ensp;{acrobaticRoutinePoints}</l><br />
                                        <l className="fw-bold"><Label data="HeaderFreeRoutine"/>&ensp;{freeRoutinePoints}</l><br />
                                        <l className="fw-bold"><Label data="HeaderTechnicalRoutine"/>&ensp;{technicalRoutinePoints}</l><br />
                                    </td>
                                    <td className="text-center fw-bold">{previousCompetitor?.resultData}</td>
                                    <td className="text-center fw-bold">{previousCompetitor?.resultRank}</td>
                                </tr>
                            </tbody>
                        </table>
                    </>
                    : ''
            }
        </>
    )
}

export default PreviousCompetitor;